/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Next_Step_AtInputs */

const cs_order_next_step_at = /** @type {(inputs: Order_Next_Step_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum dalšího kroku`)
};

const en_order_next_step_at = /** @type {(inputs: Order_Next_Step_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next step date`)
};

/**
* | output |
* | --- |
* | "Next step date" |
*
* @param {Order_Next_Step_AtInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const order_next_step_at = /** @type {((inputs?: Order_Next_Step_AtInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Next_Step_AtInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_order_next_step_at(inputs)
	return cs_order_next_step_at(inputs)
});